<template>
    <div class="popup" v-show="showPopup">
        <div class="inner">
            <div class="inner-tit">{{title}}</div>
            <div class="inner-text" v-html="popupText"></div>
            <div class="inner-btn" @click="getClose">知道了</div>
        </div>
    </div> 
</template>
<script>
export default {
    name:'tips',
    props:{
        value: {
            type: Boolean,
            default: false
        },
        popupText:{
            type:String,
            default:''
        },
        title:{
           type:String,
           default:''
       }
    },
    watch: {
      value(val) {
        this.showPopup = val;
      },
      showPopup(val) {
        this.$emit('input', val);
      },
    },
    data(){
        return{
          showPopup: this.value,
        }
    },
    methods:{
        getClose(){
            this.showPopup = false;
            // this.$emit('getCloseFun',true);
        }
    },
}
</script>
<style lang="scss">
// 提示框
.popup{
    position: fixed;
    left:0;
    top:0;
    z-index: 2;
    width:100%;
    height:100%;
    background: rgba(0,0,0,0.6);
    .inner{
        position: absolute;
        left: 50%;
        top:50%;
        width:580px;
        // height:340px;
        background: #fff;
        transform: translate(-50%,-50%);
        border-radius: 30px;
        font-size: 28px;
        .inner-tit{
            width: 100%;
            height:140px;
            line-height: 140px;
            text-align: center;
            border-bottom: 1px solid #eee;
        }
        .inner-text{
            width: 100%;
            // height: 200px;
            //text-align: center;
            color: #999999;
            padding: 20px 50px;
        }
        .inner-btn{
            width: 100%;
            height: 140px;
            line-height: 140px;
            text-align: center;
            color: #006EFF;
            border-top: 1px solid #eee;
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
        }
    }
}
</style>